import type { LibraTicket } from 'features/libra/ticket/libraTicketsApi'
import {
  compareTicketVersionThenRecency,
  getLatestTicketPerAssetForStats,
  groupTicketsByAssessment,
} from 'features/libra/ticket/ticketVersioning'

/** One assessment's versions, newest first. Becomes one card. */
export interface TicketChain {
  id: string
  versions: LibraTicket[]
}

export interface IndexedUnit {
  unitId: string
  chains: TicketChain[]
  /** Source for asset-scope field pills: the latest completed ticket, else the latest. */
  statsTicket: LibraTicket | undefined
}

/** Groups tickets by unit, then into version chains. Tickets without a unit are skipped. */
export function indexTickets(
  tickets: ReadonlyArray<LibraTicket>
): IndexedUnit[] {
  const statsTicketByUnit = new Map(
    getLatestTicketPerAssetForStats(tickets).map((ticket) => [
      ticket.tags.unit,
      ticket,
    ])
  )

  const chainsByUnit = new Map<string, TicketChain[]>()
  groupTicketsByAssessment(tickets).forEach((versions, id) => {
    const sorted = [...versions].sort(compareTicketVersionThenRecency)
    const unitId = sorted[0]?.tags.unit
    if (!unitId) return
    const chains = chainsByUnit.get(unitId) ?? []
    chains.push({ id, versions: sorted })
    chainsByUnit.set(unitId, chains)
  })

  return [...chainsByUnit].map(([unitId, chains]) => ({
    unitId,
    chains,
    statsTicket: statsTicketByUnit.get(unitId),
  }))
}
